<script>
    import ComponentTablePropsMixin
        from "../../component-table/mixins/ComponentTablePropsMixin";

    export default {
        name: "InfinitePaginationTablePropsMixin",
        mixins: [ComponentTablePropsMixin],
        props: {
            page: {
                type: Number,
                default: 1
            },
            countPerPage: {
                type: Number,
                default: 15
            },
            /** pageNumber 와 pageSize 로 데이터를 반환하는 콜백함수 */
            next: {
                type: Function,
                default: undefined,
            },
            /** 페이지네이션은 하되 페이지네이션 영역을 보이지 않게 숨깁니다. */
            hidePagination: {
                type: Boolean,
                default: false,
            },
            /** 한 번에 모든 데이터를 로드합니다. 이 값이 true 이면 페이지네이션 영역은 숨겨집니다. */
            fullLoad: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>